angular.module('billing').controller('BillingCtrl',
             [ '$scope', 'BillingRepository', 'PatientPortalStorageRepository', 'BillingService', 'TransitionManager', '$uibModal', 'aprgettext', '$state', 'LocalStorageRepository', 'LogOffService', 'AppRoutes',  'toaster', '$q', 'BrowserService',
    function ( $scope,    BillingRepository,   PatientPortalStorageRepository,   BillingService,   TransitionManager,   $modal,      gettext,      $state,   LocalStorageRepository,   LogOffService,   AppRoutes,    toaster,   $q,   BrowserService)
    {
            'use strict';

            $scope.loginUser = PatientPortalStorageRepository.getLoginUser();
            $scope.loadingPaymentHistory = true;
            $scope.loadingBillingAccount = true;
            $scope.loadingReceipt = true;
            $scope.loadingStatementHistory = true;
            $scope.viewMakeAPaymentFeature = true;
            $scope.viewLedgerFeature = true;
            $scope.viewStatementFeature = true;
            $scope.modalPrint = false;
            $scope.model = {
                Date: '',
                PersonBalanceAll: '',
                DepositByFinancialCenterEnabled: false,
                MerchantIdByFinancialCenterEnabled: false,
                DefaultMerchantId: '',
                FinancialCenterBalances: [],
                ShowMultipleFinancialCenters: false,
                ConsentAnnual: {
                    Mask: '',
                    CardType: '',
                    ExpDate: '',
                    ConsentId: '',
                    RemainingInConsent: '',
                    PerChargeLimit: ''
                },
                PaymentHistory: [],
                StatementHistory: [],
                ReceiptHtml: '',
                ActiveTxId: '',
            };

            function loadPage() {
                $scope.loginUser = PatientPortalStorageRepository.getLoginUser();
                $scope.viewMakeAPaymentFeature = BillingService.getViewMakeAPaymentFeatureFlag();
                $scope.viewLedgerFeature = BillingService.getViewLedgerFeatureFlag();
                $scope.viewStatementFeature = BillingService.getViewStatementFeatureFlag();
                $scope.ledgerAvailable = PatientPortalStorageRepository.getIsAccountResponsiblePartyForPatient();

                //determine whether this is statement only
                $scope.statementsOnly =  $state.current.alternativeLoginRoute;

                $scope.removeHttpError();
                var promises = [];
                if ($scope.viewStatementFeature) {
                    promises.push(loadStatementHistory());
                }

                if ($scope.viewMakeAPaymentFeature) {
                    promises.push(loadBillingAccount());
                    promises.push(loadPaymentHistory());
                }

                if (!promises.length) {
                    return;
                }

                $q.all(promises).catch(function (response) {
                    $scope.addHttpError(response);
                });
            }

            function loadBillingAccount() {
                $scope.loadingBillingAccount = true;
                var requestDto = {
                    LoginUserPatientId: $scope.loginUser.id,
                    RemoteSessionId: $scope.loginUser.id + new Date().toLocaleDateString()
                };

            // AccountBalanceDto
            //     decimal: PersonBalanceAll
            //     DateTime: Date
            //     Boolean: DepositByFinancialCenterEnabled
            //     Boolean: MerchantIdByFinancialCenterEnabled
            //     Int32: DefaultMerchantId
            //     IEnumerable<FinancialCenterBalanceDto>: FinancialCenterBalances
            // FinancialCenterBalanceDto
            //     decimal: Balance
            //     Guid: FinancialCenterUid
            //     String: FinancialCenterName
            //     Int32: MerchantId
                return BillingService
                    .getBillingAccount(requestDto)
                    .then(function (billingAccountDto) {
                        $scope.model.PersonBalanceAll = billingAccountDto.PersonBalanceAll;
                        $scope.model.Date = billingAccountDto.Date;
                        $scope.model.ConsentAnnual = billingAccountDto.ConsentAnnual;
                        $scope.model.DepositByFinancialCenterEnabled = billingAccountDto.DepositByFinancialCenterEnabled;
                        $scope.model.MerchantIdByFinancialCenterEnabled = billingAccountDto.MerchantIdByFinancialCenterEnabled;
                        $scope.model.DefaultMerchantId = billingAccountDto.DefaultMerchantId;
                        $scope.model.FinancialCenterBalances = billingAccountDto.FinancialCenterBalances;
                        $scope.model.ShowMultipleFinancialCenters = (!!$scope.model.FinancialCenterBalances && $scope.model.FinancialCenterBalances.length > 1);
                    })
                    .finally(function () {
                        $scope.loadingBillingAccount = false;
                    });
            }

            function loadPaymentHistory() {
                $scope.loadingPaymentHistory = true;
                var requestDto = {
                    LoginUserPatientId: $scope.loginUser.id,
                    RemoteSessionId: $scope.loginUser.id + new Date().toLocaleDateString()
                };

                return BillingRepository
                    .getPaymentHistory(requestDto)
                    .then(function (paymentHistoryArray) {
                        if (paymentHistoryArray) {
                            $scope.model.PaymentHistory = _(paymentHistoryArray.plain()).map(function (entry) {
                                return _.assign(entry, {Downloading : false});
                            }).value();
                        }
                    })
                    .finally(function () {
                        $scope.loadingPaymentHistory = false;
                    });
            }

            function loadStatementHistory() {
                $scope.loadingStatementHistory = true;

                return BillingService.getStatementHistory($scope.loginUser.id)
                    .then(function (data) {
                        $scope.model.StatementHistory = data;
                    })
                    .finally(function () {
                        $scope.loadingStatementHistory = false;
                    });
            }
            // , opts: {txId: data.TxId}
            // :amount/:merchantId/:financialCenterUid
            function makeSpecificOnlinePayment(balance) {
                if ($scope.model.ConsentAnnual && $scope.model.ConsentAnnual.CardType) {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({appRoute: 'paymentOptionsStatementsOnly',
                            opts: {amount: balance.Balance, merchantId: balance.MerchantId, financialCenterUid: balance.FinancialCenterUid }});
                    } else {
                        TransitionManager.transition({appRoute: 'paymentOptions',
                            opts: {amount: balance.Balance, merchantId: balance.MerchantId, financialCenterUid: balance.FinancialCenterUid }});
                    }
                } else {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({appRoute: 'paymentFromNewCardStatementsOnly',
                            opts: {amount: balance.Balance, merchantId: balance.MerchantId, financialCenterUid: balance.FinancialCenterUid }});
                    } else {
                        TransitionManager.transition({
                            appRoute: 'paymentFromNewCard',
                            opts: {amount: balance.Balance, merchantId: balance.MerchantId, financialCenterUid: balance.FinancialCenterUid }
                        });
                    }
                }
            }
            function makeGenericOnlinePayment() {
                if ($scope.model.ConsentAnnual && $scope.model.ConsentAnnual.CardType) {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({appRoute: 'paymentOptionsStatementsOnly', opts: {amount: $scope.model.PersonBalanceAll, merchantId: $scope.model.DefaultMerchantId, financialCenterUid: $scope.model.FinancialCenterUid }});
                    } else {
                        TransitionManager.transition({appRoute: 'paymentOptions', opts: {amount: $scope.model.PersonBalanceAll, merchantId: $scope.model.DefaultMerchantId, financialCenterUid: $scope.model.FinancialCenterUid }});
                    }
                } else {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({appRoute: 'paymentFromNewCardStatementsOnly', opts: {amount: $scope.model.PersonBalanceAll, merchantId: $scope.model.DefaultMerchantId, financialCenterUid: $scope.model.FinancialCenterUid }});
                    } else {
                        TransitionManager.transition({appRoute: 'paymentFromNewCard', opts: {amount: $scope.model.PersonBalanceAll, merchantId: $scope.model.DefaultMerchantId, financialCenterUid: $scope.model.FinancialCenterUid }});
                    }
                }
            }

            function viewReceipt(txId) {
                $scope.modalPrint = true;
                var modalInstance = $modal.open({
                    templateUrl: '/billing/views/modals/receiptModal.html',
                    controller: 'ReceiptModalCtrl',
                    resolve: {
                        loginUserId: function () {
                            return $scope.loginUser.id;
                        },
                        txId: function () {
                            return txId;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.modalPrint = false;
                });
            }

            function viewStatement() {
                //use with pdf viewer
                $scope.modalPrint = true;
                var modalInstance = $modal.open({
                    templateUrl: '/billing/views/modals/statementModal.html',
                    controller: 'StatementModalCtrl',
                    size: 'lg',
                    resolve: {
                        loginUser: function () {
                            return $scope.loginUser;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.modalPrint = false;
                });
            }

            function viewLedger() {
                //use with pdf viewer
                $scope.modalPrint = true;
                var modalInstance = $modal.open({
                    templateUrl: '/billing/views/modals/ledgerModal.html',
                    controller: 'LedgerModalCtrl',
                    size: 'lg',
                    resolve: {
                        loginUser: function () {
                            return $scope.loginUser;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.modalPrint = false;
                });
            }

            function downloadLedger(documentId) {
                documentId = $scope.loginUser.id;
                return BillingRepository.getLedgerUrl(documentId)
                    .then(function (data) {
                        return {Data: data.Data, Extension: 'pdf', FileName: 'Ledger' + '_' + $scope.loginUser.fullName};
                    });
            }

            function viewLedgerPdf() {
                $scope.modalPrint = true;

                var modalConfig = {
                    Title: gettext('Ledger'),
                    DownloadFileName: '',
                    PatientId: $scope.loginUser.id,
                    DocumentId: $scope.loginUser.id,
                    DocumentLoad: getLedgerPdf,
                    DocumentDownload: downloadLedger,
                    DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/views/viewDocumentModal.html',
                    controller: 'ViewDocumentModalCtrl',
                    windowClass: 'modal-full',
                    resolve: {
                        modalConfig: function () {
                            return modalConfig;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.modalPrint = false;
                });
            }

            function getLedgerPdf(documentId) { 
                documentId = $scope.loginUser.id; 
                return BillingRepository.getLedgerUrl(documentId); 
            }

            function getStatementHistoryItemPdf(documentId) {
                return BillingRepository.getStatementHistoryItemPdf($scope.loginUser.id, documentId);
            }

            function downloadStatementHistoryItem(historyItem) {
                historyItem.Downloading = true;
                return BillingRepository.getStatementHistoryItemPdf($scope.loginUser.id, historyItem.Id)
                    .then(function (data) {
                        return {Data: data.Data, Extension: 'pdf', FileName: 'Statement' + '_' + $scope.loginUser.fullName};
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred while downloading the statement'));
                    })
                    .finally(function () {
                        historyItem.Downloading = false;
                    });
            }

            function viewStatementHistoryItem(statementHistoryItem) {
                $scope.modalPrint = true;

                var modalConfig = {
                    Title: gettext('Statement: ') + moment(statementHistoryItem.Date).format('LL'),
                    DownloadFileName: '',
                    PatientId: $scope.loginUser.id,
                    DocumentId: statementHistoryItem.Id,
                    DocumentLoad: getStatementHistoryItemPdf,
                    DocumentDownload: getStatementHistoryItemPdf,
                    DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/views/viewDocumentModal.html',
                    controller: 'ViewDocumentModalCtrl',
                    windowClass: 'modal-full',
                    resolve: {
                        modalConfig: function () {
                            return modalConfig;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.modalPrint = false;
                });
            }

            function logOff() {
               // var statementId = LocalStorageRepository.getStatementId();
                PatientPortalStorageRepository.removeFeatureList();
                LogOffService.logoff().then(function () {
                    TransitionManager.transition({ appRoute: AppRoutes.statementslogin.state});
                });
            }

            $scope.viewStatement = viewStatement;
            $scope.viewLedger = viewLedger;
            $scope.viewLedgerPdf = viewLedgerPdf;
            $scope.viewReceipt = viewReceipt;
            $scope.makeSpecificOnlinePayment = makeSpecificOnlinePayment;
            $scope.makeGenericOnlinePayment = makeGenericOnlinePayment;
            $scope.viewStatementHistoryItem = viewStatementHistoryItem;
            $scope.downloadStatementHistoryItem = downloadStatementHistoryItem;
            $scope.logOff = logOff;
            loadPage();
        }
    ]
);

